import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { COMPANY } from "@/data/site";

export default function CTASection({
  title = "Need a Plumber in Stoughton, MA?",
  subtitle = "Call now for fast, honest service — or request a free quote and we'll get back to you quickly.",
  variant = "dark",
}) {
  const isDark = variant === "dark";
  return (
    <section
      data-testid="cta-section"
      className={`${isDark ? "bg-[#0F172A] text-white" : "bg-slate-50 text-[#0F172A]"} py-16 lg:py-24`}
    >
      <div className="max-w-5xl mx-auto px-6 lg:px-8 text-center">
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight mb-4">
          {title}
        </h2>
        <p className={`max-w-2xl mx-auto text-base lg:text-lg ${isDark ? "text-slate-300" : "text-slate-600"}`}>
          {subtitle}
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-3">
          <a href={`tel:${COMPANY.phoneTel}`} data-testid="cta-call-now-button" className="inline-flex">
            <Button className="rounded-none bg-[#0284C7] hover:bg-[#0369A1] text-white font-semibold text-base px-8 py-6 w-full sm:w-auto">
              <Phone className="h-5 w-5 mr-2" strokeWidth={1.75} />
              Call {COMPANY.phone}
            </Button>
          </a>
          <Link to="/quote" data-testid="cta-quote-button" className="inline-flex">
            <Button
              variant="outline"
              className={`rounded-none font-semibold text-base px-8 py-6 w-full sm:w-auto ${
                isDark
                  ? "bg-transparent border-2 border-white text-white hover:bg-white hover:text-[#0F172A]"
                  : "border-2 border-[#0F172A] text-[#0F172A] hover:bg-[#0F172A] hover:text-white"
              }`}
            >
              Request Free Quote
              <ArrowRight className="h-5 w-5 ml-2" strokeWidth={1.75} />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}
